import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { clearGlobalPopUpWrapper } from '../actions';
import { POPUP_LIST_NAME } from '../../../configs';
import { dateFormatter, dateTimeFormatter, infoFormatterIntl } from '../../../utils/formatters';
import { getViolationData } from '../../Violations/reducer';
import { loadViolationsById } from '../../Violations/actions';
import { responseLogWithNotification } from '../../../utils/utils';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function ViolationDetailsPopUp(props) {
  const {
    id,
  } = props;
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const {
    currentViolation: current = {},
    loadingCurrentViolation,
  } = useSelector(getViolationData);

  const {
    violation,
    koap,
    uin,
    resolution_at,
    sum,
    created_at,
    driver_document,
  } = current;

  useEffect(() => {
    dispatch(loadViolationsById(id)).catch(responseLogWithNotification);
  }, []);

  return (
    <div className={classNames('full-view custom-scroll-theme')}>
      <TimerLoader loading={loadingCurrentViolation} />
      <div className="full-view-header">
        <div>{formatMessage({ id: 'driver.card.menu.violations.details' })}</div>
        <Icons onClick={() => dispatch((clearGlobalPopUpWrapper({ key: POPUP_LIST_NAME.VIOLATION_DETAIL, id })))} customIcon icon="close" />
      </div>
      <div className="full-view-content">
        <Row className="row-cols-1">
          {infoFormatterIntl('violation.violation', violation, {}, 'user.violation')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('violation.article', koap, {}, 'user.article')}
          {infoFormatterIntl('violation.uin', uin, {}, 'user.uin')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('violation.violation_date_time', dateTimeFormatter(created_at), {}, 'user.violation_date')}
          {infoFormatterIntl('violation.resolution_date', dateFormatter(resolution_at), {}, 'user.resolution_date')}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('violation.sum', sum, {}, 'user.fine_amount')}
          {infoFormatterIntl('violation.driver_document', driver_document, {}, 'user.driver_document')}
        </Row>
      </div>
    </div>
  );
}
